import {
    ADD_CONFIGURATION_FAIL,
    ADD_CONFIGURATION_SUCCESS,
    ADD_CONFIGURATION_ITEM_FAIL,
    ADD_CONFIGURATION_ITEM_SUCCESS,
    DELETE_CONFIGURATION_FAIL,
    DELETE_CONFIGURATION_SUCCESS,
    BULK_DELETE_CONFIGURATION_FAIL,
    BULK_DELETE_CONFIGURATION_SUCCESS,
    DELETE_CONFIGURATION_ITEM_FAIL,
    DELETE_CONFIGURATION_ITEM_SUCCESS,
    BULK_DELETE_CONFIGURATION_ITEM_FAIL,
    BULK_DELETE_CONFIGURATION_ITEM_SUCCESS,
    EXPORT_CONFIGURATION_FAIL,
    EXPORT_CONFIGURATION_SUCCESS,
    GET_CONFIGURATION_DETAILS_FAIL,
    GET_CONFIGURATION_DETAILS_SUCCESS,
    GET_CONFIGURATION_LISTING_FAIL,
    GET_CONFIGURATION_LISTING_SUCCESS,
    RESET_CONFIGURATION_STATE,
    UPDATE_CONFIGURATION_FAIL,
    UPDATE_CONFIGURATION_SUCCESS,
    UPDATE_CONFIGURATION_ITEM_FAIL,
    UPDATE_CONFIGURATION_ITEM_SUCCESS
} from "./actionTypes"

const INIT_STATE = {
    configurationListing: [],
    configurationDetails: [],
    addConfiguration: [],
    updateConfiguration: [],
    addConfigurationItem: [],
    updateConfigurationItem: [],
    deleteConfiguration: [],
    bulkDeleteConfiguration: [],
    deleteConfigurationItem: [],
    bulkDeleteConfigurationItem: [],
    exportConfiguration: [],
    error: [],
}

const Configuration = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_CONFIGURATION_LISTING_SUCCESS:
            return {
                ...state,
                configurationListing: action.payload
            }
        case GET_CONFIGURATION_LISTING_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case GET_CONFIGURATION_DETAILS_SUCCESS:
            return {
                ...state,
                configurationDetails: action.payload
            }
        case GET_CONFIGURATION_DETAILS_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case ADD_CONFIGURATION_SUCCESS:
            return {
                ...state,
                addConfiguration: action.payload
            }
        case ADD_CONFIGURATION_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case UPDATE_CONFIGURATION_SUCCESS:
            return {
                ...state,
                updateConfiguration: action.payload
            }
        case UPDATE_CONFIGURATION_FAIL:
            return {
                ...state,
                error: action.payload,
            }
        case ADD_CONFIGURATION_ITEM_SUCCESS:
            return {
                ...state,
                addConfigurationItem: action.payload
            }
        case ADD_CONFIGURATION_ITEM_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case UPDATE_CONFIGURATION_ITEM_SUCCESS:
            return {
                ...state,
                updateConfigurationItem: action.payload
            }
        case UPDATE_CONFIGURATION_ITEM_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case DELETE_CONFIGURATION_SUCCESS:
            return {
                ...state,
                deleteConfiguration: action.payload
            }
        case DELETE_CONFIGURATION_FAIL:
            return {
                ...state,
                error: action.payload,
            }
        case BULK_DELETE_CONFIGURATION_SUCCESS:
            return {
                ...state,
                bulkDeleteConfiguration: action.payload
            }
        case BULK_DELETE_CONFIGURATION_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case DELETE_CONFIGURATION_ITEM_SUCCESS:
            return {
                ...state,
                deleteConfigurationItem: action.payload
            }
        case DELETE_CONFIGURATION_ITEM_FAIL:
            return {
                ...state,
                error: action.payload,
            }
        case BULK_DELETE_CONFIGURATION_ITEM_SUCCESS:
            return {
                ...state,
                bulkDeleteConfigurationItem: action.payload
            }
        case BULK_DELETE_CONFIGURATION_ITEM_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case EXPORT_CONFIGURATION_SUCCESS:
            return {
                ...state,
                exportConfiguration: action.payload
            }
        case EXPORT_CONFIGURATION_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case RESET_CONFIGURATION_STATE:
            return {
                ...state,
                // configurationListing: [],
                configurationDetails: [],
                addConfiguration: [],
                updateConfiguration: [],
                addConfigurationItem: [],
                updateConfigurationItem: [],
                deleteConfiguration: [],
                bulkDeleteConfiguration: [],
                deleteConfigurationItem: [],
                bulkDeleteConfigurationItem: [],
                exportConfiguration: [],
                error: [],
            }
        default:
            return state
    }
}

export default Configuration
